import { render, staticRenderFns } from "./ServiceLog.vue?vue&type=template&id=08ca02e2&scoped=true&"
import script from "./ServiceLog.vue?vue&type=script&lang=js&"
export * from "./ServiceLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ca02e2",
  null
  
)

export default component.exports